import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service'
import { finalize } from "rxjs/operators";
import { tap, catchError } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public loaderService: LoaderService){}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log("request",request)
    this.loaderService.show();
    return next.handle(request).pipe(
      tap(res => {
        // console.log(res, "result")
      }),
      finalize(() => 
      setTimeout(() => {
        this.loaderService.hide()
      },4000)
      )
    );
  }
}